import { Moment } from 'moment-timezone'

export type MomentRange = [Moment, Moment]
export type PartialMomentRange = [Moment | null, Moment | null]
export type NullableMomentRange = MomentRange | null
export type NullablePartialMomentRange = PartialMomentRange | null

export const RELATIVE_RANGE_LABELS = [
  'Today', 'Yesterday', 'This Week', 'Last Week',
  'This Month', 'Last Month', 'This Quarter',
  'Last Quarter', 'This Year', 'Last Year', 'Lifetime'
] as const

export type RelativeTimeRangeLabel = typeof RELATIVE_RANGE_LABELS[number]

export type RelativeTimeRange = {
  label: RelativeTimeRangeLabel
  timeRange?: never
}

export type AbsoluteTimeRange = {
  label?: never
  timeRange: MomentRange
}

export type PartialAbsoluteTimeRange = {
  label?: never
  timeRange: PartialMomentRange
}

export type TimeRange = RelativeTimeRange | AbsoluteTimeRange
export type PartialTimeRange = RelativeTimeRange | PartialAbsoluteTimeRange
